module.exports = __webpack_public_path__ + "ecb642634030362cc40260fc6b62bd6e.gif";